import {
    AdminCityPurchaseDetailRO,
    AdminCityPurchaseListItemRO,
    AdminCityPurchaseProviderEnum,
} from '@routellers/types/dist/openapi/city-payment/admin-city-purchase.ro';
import { CityPaymentScopeDtoEnum } from '@routellers/types/dist/openapi/city-payment/create-checkout-session.dto';

import { ApiMethodDeclaration } from '..';

export type ListAdminCityPurchasesParams = {
    scope?: CityPaymentScopeDtoEnum;
    provider?: AdminCityPurchaseProviderEnum;
    refunded?: boolean;
    cityId?: number;
    q?: string;
};

const query: ApiMethodDeclaration<
    ListAdminCityPurchasesParams | undefined,
    AdminCityPurchaseListItemRO[]
> = (params) => ({
    url: '/admin/city-purchases',
    method: 'GET',
    params,
});

const getOne: ApiMethodDeclaration<number, AdminCityPurchaseDetailRO> = (id) => ({
    url: `/admin/city-purchases/${id}`,
    method: 'GET',
});

export const cityPurchasesAdminApiDeclaration = {
    query,
    getOne,
};
